import { Link } from "react-router-dom";
import Wordmark from "@/components/Wordmark";
import Footer from "@/components/Footer";
import { fmtDate } from "@/lib/format";

/** Shared shell for the five legal pages. Readable on mobile, last-updated date shown. */
export default function LegalPage({ title, updated, intro, sections, testid, draft = false }) {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col" data-testid={testid}>
      <header className="border-b border-border sticky top-0 bg-background z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-14 flex items-center gap-4">
          <Link to="/"><Wordmark size="text-base" logoClass="w-5 h-5" /></Link>
          <Link to="/" className="ml-auto text-xs text-muted-foreground hover:text-foreground transition-colors">Back to app</Link>
        </div>
      </header>

      <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight">{title}</h1>
        <p className="text-xs text-muted-foreground mt-3 uppercase tracking-[0.18em] font-bold" data-testid="legal-updated">
          Last updated {fmtDate(updated)}
        </p>
        {draft && (
          <p className="mt-5 border border-traffic-amber text-traffic-amber text-xs p-3" data-testid="legal-draft-notice">
            DRAFT · adapted for Trifit.XPS from the Svar TriFit Wellness product legal pack and pending sign-off by
            the company. Please review before public launch.
          </p>
        )}
        {intro && <p className="mt-6 text-sm sm:text-base leading-relaxed text-muted-foreground">{intro}</p>}

        <div className="mt-8 space-y-8">
          {sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-heading text-lg font-bold tracking-tight">{i + 1}. {s.h}</h2>
              <div className="mt-2 space-y-3 text-sm leading-relaxed text-muted-foreground">
                {s.p.map((para, j) =>
                  Array.isArray(para) ? (
                    <ul key={j} className="list-disc pl-5 space-y-1.5">
                      {para.map((li, k) => <li key={k}>{li}</li>)}
                    </ul>
                  ) : (
                    <p key={j}>{para}</p>
                  )
                )}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-12 border border-border p-4 text-xs text-muted-foreground">
          Questions about this document? Write to <span className="text-foreground">privacy@trifitindia.com</span>.
          Svar TriFit Wellness Private Limited, India.
        </div>
      </main>
      <Footer />
    </div>
  );
}
